export default "__VITE_ASSET__CYfIdxdD__"